export * from './baMultiCheckbox.component'



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baMultiCheckbox/index.ts